import { render, staticRenderFns } from "./RechargeDialog.vue?vue&type=template&id=571a7f13&"
import script from "./RechargeDialog.vue?vue&type=script&lang=ts&"
export * from "./RechargeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports